import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Card } from '@scentregroup/ui'
import { useEvolvedContext } from '../context'
import withCentreSelector from '../containers/with-centre-selector'
import Markdown from '../components/markdown/'
import UnifiedHeader from '../components/unified-header'
import NationalFooter from '../components/national-footer'
import { UniversalFooter } from '../components/universal-footer'
import PageLanding from '../components/page-landing'
import pagesHoc from './pages-hoc'

const TermsAndConditions = ({ homePageInfo }) => {
  const isEvolved = useEvolvedContext()
  return (
    <Fragment>
      <UnifiedHeader />
      <PageLanding heading="Terms &amp; Conditions" dataTestId="page-title">
        <Card>
          <Markdown content={homePageInfo.termsAndConditions} />
        </Card>
      </PageLanding>
      {isEvolved ? <UniversalFooter /> : <NationalFooter />}
    </Fragment>
  )
}

TermsAndConditions.propTypes = {
  homePageInfo: PropTypes.object,
}

const getMetaData = ({ centres }) => ({
  title: `National Website Terms & Conditions | Westfield ${centres[0].country}`,
  description: `We update our site as often as is practicable, but information can change often and we can't guarantee its accuracy at any time. Read more on Westfield ${centres[0].country}'s website terms and conditions here.`,
})

export default withCentreSelector(pagesHoc(TermsAndConditions, getMetaData))
